export default {
    GET_ITEM: '/ajax/item/',
    MESSAGING_PARTICIPATION: '/messaging/participation/',
    MESSAGING_NOTIFICATIONS: '/api/messaging/stats',
    MESSAGING_EMAIL_SETTINGS: '/api/messaging/emailnotify',
    MESSAGING_SET_PARTICIPATION: '/my/profile/messaging-participation',
    SEARCH: '/search',
    SAVED_SEARCH_ADD: '/my/savedsearches/add',
    SAVED_SEARCH_REMOVE: '/my/savedsearches/remove',
    SAVED_SEARCH_NOTIFICATION: '/my/savedsearches/notification',
    GET_CATEGORY_LIST: '/categories'
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/endpoints.js